import { message } from 'antd';
import { AxiosError } from 'axios';

export const handleAxiosError = (e: unknown) => {
  const error = e as AxiosError;
  let messageError = error.message;

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);
    if (error.response.data.error) {
      messageError = error.response.data.error;
    } else if (error.response.data.message) {
      messageError = error.response.data.message;
    }
  }
  // if (error.request) {
  //   // The request was made but no response was received
  //   // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
  //   // http.ClientRequest in node.js
  //   console.log(error.request);
  //   // return message.error(error.request);
  // }
  if (messageError === 'Internal Server Error' || !error.message) {
    messageError = 'Đã xảy ra lỗi, vui lòng kiểm tra lại!';
  }
  return message.error(messageError);
};
